'use strict'

module.exports = {
  '10400' : '非法请求',
  '10401' : '未验证',
  '10403' : '无权限',
  '10404' : '未找到资源',
  '10500' : '服务器错误',

  '10000' : 'ok',
  '10001' : '未登录',
  '10010' : 'exists',
  '10011' : 'non-exists',

  '20000' : '无效的客户端',
  '20001' : '无效的refresh_token',
  '20002' : '登录已过期',
  '20003' : '无效的验证码',
  '20004' : '请不要频繁获取验证码',
  '20005' : '获取用户信息失败',
  '20006' : '登录已过期',
  '20007' : '已交卷',
  '20008' : '资料审核中',
  '20009' : '收获地址不符',

  '20100' : '无效的用户名或密码',
  '20101' : '无效的密码',
  '20102' : '学号已存在',
  '20103' : '此账号已被绑定',
  '20104' : '注册失败',
  '20105' : '座机号已存在',

  '20200' : '无效的请求参数',
  '20201' : '上传失败',
  '20202' : '导入失败',
  '20203' : '添加失败',
  '20204' : '修改失败',
  '20205' : '订单创建失败',
  '20206' : '商品分类错误',
  '20207' : '订单无法删除',

  '29100' : '参数无效',
  '29101' : '摘要信息不正确',
  '29102' : '未找到有效用户',
  '29103' : '没有该课程的访问权限',
  '29200' : '未找到有效的学习记录',
  '29201' : '当前学习记录与学习模式不匹配',
  '29202' : '当前学习记录与子课程标识不匹配',
  '29203' : '当前学习记录已完成学习',
  '29204' : '当前用户类型与登录账户不符',
  '29999' : '未知错误',
}



// WEBPACK FOOTER //
// ./src/http/apicode.js